import { ApiEmployeeDepartment } from "@/types/department.types.ts";
import { ApiDivisionShort } from "@/types/division.types.ts";
import { ApiEmployee, ApiTableRowPending } from "@/types/employees/employee.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiJobProfile, getJobProfileTitle } from "@/types/job-profile.types.ts";
import { ApiLocation } from "@/types/location.types.ts";
import { ApiOrganizationListItem } from "@/types/organization-list.types.ts";
import { ApiCustomField, ApiCustomFieldValue } from "@/types/custom-field.types.ts";

export interface ApiEmployeeAssignPositionPayload {
  date_effective_from: Date;
  division_id?: number | null;
  department_id?: number | null;
  job_profile_id?: number | null;
  reporting_to_id?: number | null;
  location_id?: number | null;
  comment?: string | null;
  change_reason_id: number;
  custom_fields?: Record<string, ApiCustomFieldValue | null>;
}

export interface ApiEmployeeDepartmentManager {
  employee: ApiEmployee;
  department: ApiEmployeeDepartment;
}

export interface ApiEmployeePosition {
  id: number;
  date_effective_from: Date;
  date_effective_to?: Date;
  department?: ApiEmployeeDepartment;
  division?: ApiDivisionShort;
  job_profile?: ApiJobProfile | null;
  department_manager?: ApiEmployeeDepartmentManager;
  manager?: ApiEmployee;
  location?: ApiLocation;
  comment?: string;
  changed_by?: ApiEmployee | null;
  change_reason: ApiOrganizationListItem | null;
  custom_fields?: ApiCustomField[];
}

export interface ApiEmployeePositionPendingRow extends Omit<
  ApiEmployeePosition,
  "id" | "date_effective_from" | "date_effective_to"
> {
  id: number | null;
  date_effective_from: Date | null;
  date_effective_to: Date | null;
  pending: ApiTableRowPending;
}

export interface ApiEmployeePositionPagedData extends ApiPagedData<ApiEmployeePosition> {
  pending_rows: ApiEmployeePositionPendingRow[];
}

export const getEmployeePositionTitle = (employee: ApiEmployee): string => {
  const employeePosition = employee.employee_position;
  return employeePosition?.job_profile ? getJobProfileTitle(employeePosition.job_profile) : "";
};
